<template>
  <div class="fixed-footer">
    <div class="box" v-if="!fixed" :style="`height: ${height + 16}px`"></div>
    <div class="main" v-if="!fixed" ref="main">
      <slot/>
    </div>
    <slot v-if="fixed"/>
  </div>
</template>

<script>
export default {
  name: 'FixedFooter',
  props: {fixed: {type: Boolean, default: false}},
  data() {
    return {height: 52, scroll: 0}
  },
  created() {
  },
  mounted() {

  },
  computed: {},
  methods: {
    hasScrollbar() {
      return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight)
    },
    menu() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
    },
  },
}
</script>

<style lang="less" scoped>
.fixed-footer {
  width: 100%;

  .box {
    width: 100%;
  }

  .main {
    background: #fff;
    padding: 12px 20px !important;
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    z-index: 990;
    box-shadow: 0 1px 0 0 #e1e5f4 inset;
  }

  .win-72 {
    min-width: 72px;
  }
}
</style>

<style lang="less"></style>
